import React, { useMemo } from 'react';
import './NetworkSelector.scss';
import Checkbox from '../checkbox/Checkbox';
import DivideLine from '../line/DivideLine';

type NetworkSelectorProps = {
  microchainList: Array<any>;
  selectedList: Array<any>;
  setSelectedList: React.Dispatch<React.SetStateAction<any>> | Function;
  idKey?: number;
  labelKey?: string;
};

const NetworkSelector = (props: NetworkSelectorProps) => {
  const { microchainList, selectedList, setSelectedList, idKey = 'id', labelKey = 'label' } = props;
  const selectMicrochainList = useMemo(() => microchainList.filter((network) => selectedList.includes(network.id)), [microchainList, selectedList]);
  const notSelectMicrochainList = useMemo(() => microchainList.filter((network) => !selectedList.includes(network.id)), [microchainList, selectedList]);
  return (
    <div className="network-selector">
      <div className="network-selector-container">
        {selectMicrochainList.map((microchain: any) => {
          const { network } = microchain || {};
          return (
            <div className="network-selector-item" key={`network-selector-${microchain.id}`}>
              <Checkbox
                id={microchain[idKey]}
                label={network[labelKey]}
                checked={selectedList.find((id: number) => id === microchain.id) || ''}
                onChange={() => setSelectedList(microchain[idKey])}
              />
            </div>
          );
        })}
        {selectMicrochainList.length !== 0 && notSelectMicrochainList.length !== 0 && <DivideLine style={{ margin: '5px 0' }} />}
        {notSelectMicrochainList.map((microchain: any) => {
          const { network } = microchain;
          return (
            <div className="network-selector-item" key={`network-selector-${microchain.id}`}>
              <Checkbox
                id={microchain[idKey]}
                label={network[labelKey]}
                checked={selectedList.find((id: number) => id === microchain.id) || ''}
                onChange={() => setSelectedList(microchain[idKey])}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default NetworkSelector;
